// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"321":"29449da5","385":"cc1ed782"}[chunkId] + ".css";
};